export default "__VITE_ASSET__DzeGWbJx__"